<div class="customer-details-card p-20">
  <div class="row">
    <div class="col-lg-12">
      <app-card cardTitle="View Details" [padding]="20">
        <ng-template #headerOptionsTemplate>
          <a href="javascript:" class="text-muted" mat-dialog-close>
            <i class="ti ti-x f-20"></i>
        </a>
        </ng-template>
        <div class="personal-details">
          <div class="row">
            @for (col of dataColumns; track col) {
            <div class="col-md-6">
              <p class="m-b-5 text-muted"> {{col | translate}} </p>
              <div class="f-w-500">{{ viewData[col] }}</div>
            </div>
            }
          </div>
        </div>
        @if(hasDetails){
        <div>
          <table>
            <th>
              @for (col of detailsColumns; track col) {
            <td>{{col}}</td>
            }
            </th>
            @for (row of detailsArr; track row) {
            <tr>
              @for (col of detailsColumns; track col) {
              <td>{{row[col]}}</td>
              }
            </tr>
            }
          </table>


        </div>
        }
      </app-card>
    </div>
  </div>
</div>